import { render, staticRenderFns } from "./Liquidations.vue?vue&type=template&id=0190627f"
import script from "./Liquidations.vue?vue&type=script&lang=js"
export * from "./Liquidations.vue?vue&type=script&lang=js"
import style0 from "./Liquidations.vue?vue&type=style&index=0&id=0190627f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports